// @flow
import React from 'react'
import { Box, type boxProps } from 'frack-components'
import config from '../../../config.js'

type Props = boxProps

const Container = ({ fluid, ...props }: Props) => <Box maxWidth={fluid ? '100%' : 8} {...props} />

Container.defaultProps = {
  paddingHorizontal: config.gutter,
  center: true,
  width: '100%',
}

export default Container
